/*
 * @Author: Teemo Ding
 * @Date: 2022-02-09 11:15:48
 * @LastEditTime: 2022-02-25 13:53:26
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/Components/SubscriptionBuy/tool.ts
 */
//import { get } from 'lodash';
const _processProducts = (products) => {
  if (products.length < 1) {
    return [];
  } else {
    const re = products.reduce((pre, now) => {
      const { subscriptionDiscounts: _s, ...rest } = now;
      const subscriptionDiscounts = _s || [];
      //  const len = flashSaleDiscounts.length;
      if (subscriptionDiscounts.length < 1) {
        return pre;
      } else {
        const _flat = subscriptionDiscounts.map((i, index, __self) => {
          if (index === 0) {
            const len = __self.length;
            return { ...i, ...rest, rowSpan: len, subscriptionPrice: i.price };
          }
          return { ...i, ...rest, rowSpan: 0, subscriptionPrice: i.price };
        });

        return [...pre, ..._flat];
      }
    }, []);
    return re;
  }
};
const processSubscriptionDiscounts = (data) => {
  //   const { products }=data;
  const re = data.map((i) => {
    const { products } = i;

    const _products = _processProducts(products || []);
    return { ...i, products: _products };
  });
  return re;
};
export { processSubscriptionDiscounts };
